<template>
 <div>
   <div v-show="!showUpdate" class="app-content content ">
     <div class="content-overlay"></div>
     <div class="header-navbar-shadow"></div>
     <div class="content-wrapper">
       <div class="content-header row">
         <div class="content-header-left col-md-9 col-12 mb-2">
           <Breadcrumb
               name="Meta Data"
               bc1="App"
               bc2="Meta Data"
               bc3="List"
               path="card-meta-data"
           ></Breadcrumb>
         </div>
       </div>
       <div class="content-body">
         <div class="card">
           <div class="m-2">
             <div class="row">
               <div class="col-md-4 col-sm-6">
                 <select class="form-control" v-model="selectedType">
                   <option :value="null">Select Type</option>
                   <option :value="item.id" v-for="(item) in chargeTypeOption">
                     {{item.name}}
                   </option>
                 </select>
               </div>
               <div class="col-md-4 col-sm-12">
                 <button type="button" class="btn btn-primary" @click="onSubmitFilters" >Search</button>
                 <button type="button" class="ml-1 btn btn-danger "  @click="clear">Clear</button>
               </div>
             </div>
             <div class="row">
               <div class="col-md-12 col-12">
                 <div class="d-flex align-items-center justify-content-end">
                   <button
                       type="button"
                       class="btn btn-primary"
                       @click="$router.push({ name: 'add-card-meta-data' })"
                   >
                     <AddButtonText name="Meta Data" />
                   </button>
                 </div>
               </div>
             </div>
           </div>
           <CommonTableStore
               :url="url"
               :tableHeaderValues="tableHeaderValues"
               :actions="actions"
               :deleteActions="deleteActions"
               :mutedData="mutedData"
               :storageKey="storageKey"
               :externalTotalRecord="externalTotalRecord"
               :show-per-page="true"
               :filteredData="filteredData"
           />
         </div>
       </div>
     </div>
   </div>
   <UpdateMetaData @back="showUpdate = false" v-if="showUpdate" />
 </div>


</template>

<script>

import UpdateMetaData from "@/pages/dashboard/meta-data/updateMetaData.vue";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  components: {
    AddButtonText,
    UpdateMetaData
  },
  mounted() {
    this.getChargesTypes()
    localStorage.setItem("url", "v1/get-card-meta-data");
    this.checkDataInStore('v1/get-card-meta-data')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      url: "v1/get-card-meta-data",
      storageKey: "cardMetaData",
      showUpdate:false,
      selectedType: null,
      tableHeaderValues: [
        {
          title: "Title",
          valueKey: "title"
        },
        {
          title: "Alias",
          valueKey: "alias"
        },
        {
          title: "Type",
          valueKey: "type",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="badge-light-primary badge">${value.name}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }
            return html;
          }
        }
      ],
      actions: [
        {
          title: "update",
          cta: (row, index) => {
            let data = {
              ...row,
              index: index,
              row: row,
              key: "metaDataUpdate",
              storageKey: this.storageKey,
              idx: index,
            }
            this.$store.dispatch("set", data);
            this.showUpdate = true
          }
        }
      ],
      deleteActions: [
      ],
      mutedData: [],
      externalTotalRecord: "",
      chargeTypeOption: [],
      chargeTypeDetailOptions: [],
      filteredData: {},
    };
  },
  methods: {
    getChargesTypes(){
      this.makeRequest("post", "v1/get-charges-types-data", {cardMetaDataTypes: 1}, {}, false,true,[205]).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data){
                  this.chargeTypeOption = data.cardMetaDataTypes
                }

              }
            }
          }
      );
    },
    onSubmitFilters() {

      let filterData = {}
      if(this.selectedType){
        filterData.type = this.selectedType
      }
      this.filteredData = filterData

      console.log(this.selectedType, this.filteredData)
    },
    clear(){
      this.selectedType = null
      this.filteredData = {}

    },

  }
};
</script>

